import styled from 'styled-components';

import { getSpacing, fontSize, fontWeight } from 'stylesheetB2b';

export const Container = styled.div`
position: relative;
display: flex;
flex-direction: column;
align-items: center;
padding: ${getSpacing(4)};
`;
Container.displayName = 'Container';

export const Title = styled.h1`
font-size: ${fontSize.XLarge};
font-weight: 500;
margin: ${getSpacing(2)} 0;
`;
Title.displayName = 'Title';

export const SubTitle = styled.h2`
font-size: ${fontSize.medium};
font-weight: ${fontWeight.light};
margin: ${getSpacing(2)} 0;
`;
SubTitle.displayName = 'subTitle';

export const BoxEffectContainer = styled.div`
width: 100%;
display: grid;
grid-template-columns: repeat(4, 1fr);
gap: ${getSpacing(4)};
flex-direction: row;
margin-top: ${getSpacing(4)};
`;
BoxEffectContainer.displayName = 'BoxEffectContainer';

export const GoBackContaier = styled.div`
position: absolute;
left: ${getSpacing(4)};
display: flex;
align-items: center;
padding: ${getSpacing(2)};
cursor: pointer;
`;
GoBackContaier.displayName = 'GoBackContaier';
